var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"auth"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content-area"},[_c('nuxt'),_vm._v(" "),_c('f-footer')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }